export const Footer = () => {
    return (
        <footer className="footer  w-full p-4 bg-slate-100 dark:bg-[#121212] text-gray-800 dark:text-slate-100">
            <div className="text-center">
                <p>
                    Created with <a href="https://thecatapi.com/" className="underline underline-offset-2 decoration-red-200 hover:bg-red-200 hover:text-black" target="_blank" rel="noreferrer">thecatapi.com</a> and <a href="https://thedogapi.com/" className="underline underline-offset-2 decoration-red-200 hover:bg-red-200 hover:text-black" target="_blank" rel="noreferrer">thedogapi.com</a>
                </p>
            </div>
        </footer>
    )
}

